import React from 'react';
import { useAuthenticatedImage } from './useAuthenticatedImage';

/**
 * Component that displays an authenticated image using the useAuthenticatedImage hook
 * Can be used as a drop-in replacement for <img> tags
 * 
 * @param {string} src - The image path/URL (relative to imgUrl base)
 * @param {string} fallback - Optional fallback image URL if authenticated image fails or is not available
 * @param {object} ...props - All other props are passed to the underlying <img> tag
 */
const AuthenticatedImage = ({ src, fallback, ...props }) => {
  const authenticatedImageUrl = useAuthenticatedImage(src);

  return (
    <img
      {...props}
      src={authenticatedImageUrl || fallback || props.src}
    />
  );
};

export default AuthenticatedImage;
